import api from '../utils/api';

export interface RecentAlert {
  id: string;
  dealId: string;
  companyName: string;
  alertType: string;
  message: string;
  createdAt: string;
  read: boolean;
}

interface UnreadCountResponse {
  unreadCount: number;
}

interface RecentAlertsResponse {
  alerts: RecentAlert[];
}

interface MarkAllReadResponse {
  markedCount: number;
}

export const notificationAlertsApi = {
  getUnreadCount: async (): Promise<number> => {
    const { data } = await api.get<UnreadCountResponse>('/alerts/unread-count');
    return data.unreadCount;
  },

  getRecentAlerts: async (limit = 10): Promise<RecentAlert[]> => {
    const { data } = await api.get<RecentAlertsResponse>('/alerts/recent', {
      params: { limit },
    });
    return data.alerts;
  },

  markAllAsRead: async (): Promise<number> => {
    const { data } = await api.post<MarkAllReadResponse>('/alerts/mark-all-read');
    return data.markedCount;
  },
};
